// @ts-check
import React from "react";

/**
 * @param {{url?:string}} param0
 * @returns {string}
 */
const fomatWhatsAppUrl = ({ url }) => {
  if (!url || url == "") {
    return "";
  }
  if (url?.includes("http")) {
    return url;
  }
  return `https://wa.me/${url}`;
};

/**
 *
 * @param {{url?:string ; children:React.ReactNode}} param0
 * @returns
 */
const WhatsAppCard = ({ url = "", children }) => {
  return (
    <a
      href={fomatWhatsAppUrl({ url })}
      target={fomatWhatsAppUrl({ url }) != "" ? "_blank" : ""}
    >
      {children}
    </a>
  );
};
export default WhatsAppCard;
